import { Box, Typography, Avatar } from '@mui/material';
import { useAuth } from '../context/authContext';

function UserProfileContainer() {
  const { user } = useAuth();

  if (!user || Object.keys(user).length === 0) {
    return (
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        bgcolor='var(--vega-blue)'
        color='var(--dust-white)'
        padding='20px'
        boxShadow='0px 4px 8px rgba(247, 231, 229)'
        height='100vh'
        width='10%'
        position='fixed'
        sx={{
          '@media (max-width: 600px)': {
            width: '100%',
            borderRadius: 0,
            position: 'relative',
            height: 'auto',
            boxShadow: 'none',
          },
        }}
      >
        <Avatar
          sx={{
            width: 100,
            height: 100,
            marginBottom: 2,
            border: '2px solid var(--dust-white)',
          }}
        />
        <Typography
          variant='h6'
          gutterBottom
          sx={{
            fontSize: '1rem',
            textAlign: 'center',
            fontFamily: 'BrightstarSans-Regular',
          }}
        >
          Unknown User
        </Typography>
        <Typography
          variant='body1'
          gutterBottom
          sx={{
            fontSize: '0.9rem',
            textAlign: 'center',
            fontFamily: 'BrightstarSans-Regular',
          }}
        >
          Job title | Department
        </Typography>
        <Typography
          variant='body1'
          gutterBottom
          sx={{
            fontSize: '0.9rem',
            textAlign: 'center',
            fontFamily: 'BrightstarSans-Regular',
          }}
        >
          Office Location
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      bgcolor='var(--vega-blue)'
      color='var(--dust-white)'
      padding='20px'
      boxShadow='0px 4px 8px rgba(247, 231, 229)'
      height='100vh'
      width='10%'
      position='fixed'
      sx={{
        '@media (max-width: 600px)': {
          width: '100%',
          borderRadius: 0,
          position: 'relative',
          height: 'auto',
          boxShadow: 'none',
        },
      }}
    >
      {user.profilePhoto ? (
        <Avatar
          sx={{
            width: 100,
            height: 100,
            marginBottom: 2,
            border: '2px solid var(--dust-white)',
          }}
          src={user.profilePhoto}
          alt='User Profile'
        />
      ) : (
        <Avatar
          sx={{
            width: 100,
            height: 100,
            marginBottom: 2,
            border: '2px solid var(--dust-white)',
          }}
        >
          U
        </Avatar>
      )}
      <Typography
        variant='h6'
        gutterBottom
        sx={{
          fontSize: '1rem',
          textAlign: 'center',
          fontFamily: 'BrightstarSans-Regular',
        }}
      >
        {user.displayName || 'Unknown User'}
      </Typography>
      <Typography
        variant='body1'
        gutterBottom
        sx={{
          fontSize: '0.9rem',
          textAlign: 'center',
          fontFamily: 'BrightstarSans-Regular',
        }}
      >
        {user.jobTitle || ' job title'} | {user.department || 'department'}
      </Typography>
      <Typography
        variant='body1'
        gutterBottom
        sx={{
          fontSize: '0.9rem',
          textAlign: 'center',
          fontFamily: 'BrightstarSans-Regular',
        }}
      >
        {user.officeLocation || 'office location'}
      </Typography>
    </Box>
  );
}

export default UserProfileContainer;
